/**
 * 合同模板预览：付款计划表格版式（与后端 PaymentPlanMergeRenderer 样式一致，无说明文案）。
 */

function escapeHtml(s) {
  if (s == null || s === '') return ''
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function appendTh(sb, label) {
  sb.push(
    '<th style="border:1px solid #ccc;padding:6px 8px;text-align:left;background:#f3f4f6;">',
    escapeHtml(label),
    '</th>'
  )
}

function appendTd(sb, text, extraStyle) {
  sb.push(
    '<td style="border:1px solid #ccc;padding:6px 8px;vertical-align:top;',
    extraStyle || '',
    '">',
    escapeHtml(text),
    '</td>'
  )
}

/** 模板编辑预览：仅表头 + 空行示意 */
export function buildPaymentPlanTablePlaceholderPreview(opts) {
  const labels = (opts && opts.labels) || {}
  const sb = [
    '<table style="width:100%;border-collapse:collapse;font-size:11pt;margin:12px 0;">',
    '<thead><tr>'
  ]
  appendTh(sb, labels.colIndex || '#')
  appendTh(sb, labels.colMilestone || 'Milestone')
  appendTh(sb, labels.colAmount || 'Amount (USD)')
  appendTh(sb, labels.colDue || 'Due date')
  appendTh(sb, labels.colNotes || 'Notes')
  sb.push('</tr></thead><tbody><tr>')
  appendTd(sb, '—', 'text-align:center;color:#9ca3af;')
  appendTd(sb, '…', 'color:#9ca3af;font-style:italic;')
  appendTd(sb, '…', 'text-align:right;color:#9ca3af;font-style:italic;')
  appendTd(sb, '…', 'color:#9ca3af;font-style:italic;')
  appendTd(sb, '…', 'color:#9ca3af;font-style:italic;')
  sb.push('</tr></tbody></table>')
  return sb.join('')
}

export function buildPaymentPlanTextPlaceholderPreview() {
  return (
    '<pre style="margin:12px 0;padding:8px 10px;border:1px solid #e5e7eb;border-radius:4px;' +
    'font-size:10.5pt;line-height:1.55;color:#9ca3af;font-style:italic;white-space:pre-wrap;font-family:inherit;">…</pre>'
  )
}

export function applyPaymentPlanPreviewPlaceholders(html, tablePreviewHtml, textPreviewHtml) {
  if (!html) return ''
  return html
    .split('{{payment_plan_table}}')
    .join(tablePreviewHtml || '')
    .split('{{payment_plan_text}}')
    .join(textPreviewHtml || '')
}
